<template>
  <div class="szw-flex szw-h-[150px] szw-gap-4 szw-items-center szw-justify-center">
    <div class="szw-flex szw-flex-col szw-gap-1">
      <div class="szw-h-[24px] szw-w-[80px] szw-bg-color-disable szw-animate-pulse szw-rounded" />
      <div class="szw-h-[16px] szw-w-[80px] szw-bg-background-color-secondary szw-animate-pulse szw-rounded" />
    </div>

    <div class="szw-flex szw-h-[120px] szw-w-[120px] szw-justify-center szw-items-center szw-rounded-full szw-bg-color-disable szw-animate-pulse">
      <div class="szw-h-[96px] szw-w-[96px] szw-rounded-full szw-bg-background" />
    </div>

    <div class="szw-flex szw-flex-col szw-gap-1">
      <div class="szw-h-[24px] szw-w-[80px] szw-bg-color-disable szw-animate-pulse szw-rounded" />
      <div class="szw-h-[16px] szw-w-[80px] szw-bg-background-color-secondary szw-animate-pulse szw-rounded" />
    </div>
  </div>

  <div class="szw-flex szw-flex-col szw-w-full szw-rounded szw-gap-1" v-for="line of 8" :key="line">
    <div class="szw-flex szw-w-full szw-items-center">
      <span class="szw-w-[36px] szw-h-[20px] szw-rounded szw-bg-color-disable szw-animate-pulse"></span>

      <span class="szw-w-[64px] szw-h-[16px] szw-rounded szw-bg-color-disable szw-animate-pulse szw-mx-auto"></span>

      <span class="szw-w-[36px] szw-h-[20px] szw-rounded szw-bg-color-disable szw-animate-pulse"></span>
    </div>

    <div class="szw-h-[6px] szw-w-full szw-rounded szw-bg-background-color-secondary szw-animate-pulse" />
  </div>
</template>
